import React, { useState } from 'react';
import ProposalService from '../../services/ProposalService';
import { openNotification } from '../../utils';

interface ProposalViewProps {
    proposalId: number;
    proposalUrl?: string | null;
}

const ProposalView: React.FC<ProposalViewProps> = ({ proposalId, proposalUrl }) => {
    const [downloading, setDownloading] = useState(false);

    const resolveProposalPdfUrl = async () => {
        try {
            const latestArchiveResponse = await ProposalService.getLatestPdfArchive(proposalId);
            const latestArchiveUrl = latestArchiveResponse?.data?.pdfUrl;

            if (latestArchiveUrl) {
                return latestArchiveUrl;
            }
        } catch {
            // Eski proposalUrl fallback'i için archive hatasını yutuyoruz.
        }

        if (proposalUrl) {
            return proposalUrl;
        }

        const response = await ProposalService.get(proposalId);
        const detailProposalUrl = response?.data?.proposalUrl;

        return detailProposalUrl || null;
    };

    const handleDownload = async () => {
        if (downloading) {
            return;
        }

        const pdfWindow = window.open('', '_blank');
        if (!pdfWindow) {
            openNotification('error', 'Hata', 'PDF yeni sekmede açılamadı. Lütfen tarayıcı pop-up iznini kontrol ediniz.');
            return;
        }

        setDownloading(true);
        try {
            const pdfUrl = await resolveProposalPdfUrl();

            if (!pdfUrl) {
                pdfWindow.close();
                openNotification('error', 'Hata', 'Teklife ait PDF bulunamadı.');
                return;
            }

            pdfWindow.location.href = pdfUrl;
        } catch (error: any) {
            pdfWindow.close();
            const message =
                error?.response?.data?.message ||
                error?.message ||
                'Teklif PDF’i yeni sekmede açılırken hata oluştu.';
            openNotification('error', 'Hata', message);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div style={{ width: '100% !important'}} onClick={handleDownload}>
            Teklif Görüntüle
        </div>
    );
};

export default ProposalView;
